/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_New_Folder_ButtonInputs */

const en_explorer_nav_new_folder_button = /** @type {(inputs: Explorer_Nav_New_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder`)
};

const fr_explorer_nav_new_folder_button = /** @type {(inputs: Explorer_Nav_New_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dossier`)
};

const de_explorer_nav_new_folder_button = /** @type {(inputs: Explorer_Nav_New_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordner`)
};

const it_explorer_nav_new_folder_button = /** @type {(inputs: Explorer_Nav_New_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartella`)
};

const ru_explorer_nav_new_folder_button = /** @type {(inputs: Explorer_Nav_New_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Папка`)
};

const es_explorer_nav_new_folder_button = /** @type {(inputs: Explorer_Nav_New_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpeta`)
};

const zh_cn2_explorer_nav_new_folder_button = /** @type {(inputs: Explorer_Nav_New_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件夹`)
};

const ja_explorer_nav_new_folder_button = /** @type {(inputs: Explorer_Nav_New_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダ`)
};

const hi_explorer_nav_new_folder_button = /** @type {(inputs: Explorer_Nav_New_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर`)
};

const pt_pt2_explorer_nav_new_folder_button = /** @type {(inputs: Explorer_Nav_New_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasta`)
};

/**
* | output |
* | --- |
* | "Folder" |
*
* @param {Explorer_Nav_New_Folder_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_new_folder_button = /** @type {((inputs?: Explorer_Nav_New_Folder_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_New_Folder_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_new_folder_button(inputs)
	if (locale === "de") return de_explorer_nav_new_folder_button(inputs)
	if (locale === "it") return it_explorer_nav_new_folder_button(inputs)
	if (locale === "ru") return ru_explorer_nav_new_folder_button(inputs)
	if (locale === "es") return es_explorer_nav_new_folder_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_new_folder_button(inputs)
	if (locale === "ja") return ja_explorer_nav_new_folder_button(inputs)
	if (locale === "hi") return hi_explorer_nav_new_folder_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_new_folder_button(inputs)
	return en_explorer_nav_new_folder_button(inputs)
});